import InvestorModel from './murabaha_investor';
import PropertyHolding from './property_holding';

interface ITransferUnitsDto {
  propertyId?: number;
  property?: PropertyHolding;

  userId?: string;
  investor?: InvestorModel;

  numberOfUnits?: number;

  isSearchingInvestor?: boolean;
  isStateLoading?: boolean;
}

class TransferUnitsDto implements ITransferUnitsDto {
  propertyId?: number;
  property?: PropertyHolding;

  userId?: string;
  investor?: InvestorModel;
  numberOfUnits?: number;
  isSearchingInvestor?: boolean;
  isStateLoading?: boolean;

  constructor(data?: Partial<ITransferUnitsDto>) {
    this.propertyId = data?.propertyId;
    this.property = data?.property;
    this.userId = data?.userId;
    this.investor = data?.investor;
    this.numberOfUnits = data?.numberOfUnits;
    this.isSearchingInvestor = data?.isSearchingInvestor;
    this.isStateLoading = data?.isStateLoading;
  }

  copyWith(data: Partial<ITransferUnitsDto>): TransferUnitsDto {
    return new TransferUnitsDto({
      propertyId: data.propertyId ?? this.propertyId,
      property: data.property ?? this.property,
      userId: data.userId ?? this.userId,
      investor: data.investor ?? this.investor,
      numberOfUnits: data.numberOfUnits ?? this.numberOfUnits,
      isSearchingInvestor: data.isSearchingInvestor ?? this.isSearchingInvestor,
      isStateLoading: data.isStateLoading ?? this.isStateLoading,
    });
  }

  copyWithNoInvestor(): TransferUnitsDto {
    return new TransferUnitsDto({
      ...this,
      investor: undefined,
      isSearchingInvestor: false,
    });
  }

  /** Check if the DTO is valid */
  get isValidDto(): boolean {
    return (
      !!this.propertyId &&
      !!this.property &&
      !!this.userId &&
      !!this.investor &&
      !!this.numberOfUnits &&
      this.numberOfUnits > 0 &&
      this.numberOfUnits <= this.property.units_owned
    );
  }

  // return { units: 1, property: 5, from_user: 15, to_user: 3731 };
  toTransferDto(murabaha_user_id: string) {
    return {
      units: this.numberOfUnits,
      property: this.propertyId,
      from_user: murabaha_user_id,
      to_user: this.userId,
    };
  }
}

export default TransferUnitsDto;
